import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IEnvironment } from 'src/environments/environment.model';

import { FeedbackRequest } from 'src/app/modules/core/models/feedback.model';
import { SettingsService } from 'src/app/modules/core/services/settings.service';

import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';

@Injectable({
	providedIn: 'root'
})
export class FeedbackService extends UnsubscribeOnDestroy {
	private settings!: IEnvironment;

	constructor(
		private http: HttpClient,
		settingsService: SettingsService
	) {
		super();

		settingsService.getSettings().pipe(
			this.takeUntilDestroyed()
		).subscribe(settings => {
			this.settings = settings;
		});
	}

	submitFeedback(feedback: FeedbackRequest): Observable<void> {
		const url = `${this.settings?.apiUrl}feedback`;
		return this.http.post<void>(url, feedback);
	}
}
